import {useQuery} from '@tanstack/react-query';

import {ENDPOINTS} from 'constants/endpoints';

import {apiConfig} from 'libs/api/api';
import {logWithSentry} from 'libs/sentry/sentry';
import {CheckoutItemType} from 'mobile/pages/checkout/types/checkoutItemsType';

export const CART_ITEMS_V2_QUERY_KEY = ['cartItemsV2', ENDPOINTS.GET_CART_ITEMS_V2];

/**
 * react query hook for getting cart items
 */
export const useCartItemsV2 = ({enabled} = {enabled: true}) => {
    const {
        data: items,
        isLoading,
        refetch,
    } = useQuery({
        enabled,
        queryFn: async ({queryKey}) => {
            const [, endpoint] = queryKey;
            try {
                const {data} = await apiConfig.instanceGusaBackend({
                    method: 'GET',
                    url: endpoint,
                });
                return data as CheckoutItemType[];
            } catch (error) {
                logWithSentry(error, 'There are no items to show');
                return [];
            }
        },
        queryKey: CART_ITEMS_V2_QUERY_KEY,
        refetchOnWindowFocus: false,
        staleTime: 3000, // need to prevent double request during first render
    });

    return {isLoading, items, refetch};
};
